import { createRootRouteWithContext } from "@tanstack/react-router";

import { AppShell } from "../app/app-shell";

export interface RouterContext {
  // Reserved for future context (e.g. injected services). Kept empty for now.
}

export const __rootRoute = createRootRouteWithContext<RouterContext>()({
  component: AppShell,
});
